module.exports = __webpack_public_path__ + "img/aws-cloud-practitioner.dd8119d7.png";